import React from 'react'

import { Formik } from 'formik'

import { Table } from '_zari/core'

import * as Cells from './cells'

const MainRow = ({ row, dispatch }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      precio: row.precio ?? '',
      flagAlmacen: row.flagAlmacen ?? false,
      flagOrdenCompra: row.flagOrdenCompra ?? false
    }
  }, [row])

  return (
    <Formik initialValues={formInitialValues}>
      {({ errors, touched, values, handleChange, setFieldValue }) => (
        <Table.Row>
          <Table.Cell>{row._idUsuario ?? '--'}</Table.Cell>
          <Table.Cell>{row.nombreProducto ?? '--'}</Table.Cell>
          <Table.Cell>{row.oficinaSolicitante ?? '--'}</Table.Cell>
          <Table.Cell style={{ width: 70 }} className='text-center'>
            {row.cantidad ?? '--'}
          </Table.Cell>
          <Table.Cell>{row.unidadMedida ?? '--'}</Table.Cell>
          <Cells.PrecioCell
            row={row}
            dispatch={dispatch}
            handleChange={handleChange}
            iError={errors.precio}
            iTouched={touched.precio}
          />
          <Cells.FlagAlmacenCell
            row={row}
            dispatch={dispatch}
            iValue={values.flagAlmacen}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
          <Cells.FlagOrdenCompraCell
            row={row}
            dispatch={dispatch}
            iValue={values.flagOrdenCompra}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </Table.Row>
      )}
    </Formik>
  )
}

export default React.memo(MainRow)
